import type { Table } from 'dexie';
import type { NomadDB } from '~/db/NomadDB';
import { dataClear } from '~/lib/data/clear';
import { getServices } from '~/db/services';

export const dataSave = (db: NomadDB) => {
  const { importsService } = getServices(db);
  const { clearCollection, clearLibraryBookCollection } = dataClear(db);

  const saveCollectionItems = async (
    collection: CollectionTypes,
    items: any[],
    clearForced: boolean = false,
    data: object = null,
    source?: string
  ) => {
    try {
      await db.transaction('rw', db[collection], db.imports, async () => {
        const table = db[collection] as Table;
        await clearCollection(collection, clearForced, source);
        await table.bulkPut(items);
        await importsService.save(collection, '', data);
      });
    } catch (error) {
      if (globalThis.$logger)
        globalThis.$logger.error('saveCollectionItems', collection, error);
      throw error;
    }
  };

  const saveLibraryBookCollectionItems = async (
    libraryBookId: string,
    collection: CollectionTypes,
    items: any[],
    source?: string
  ): Promise<void> => {
    try {
      await db.transaction('rw', db[collection], db.imports, async () => {
        const table = db[collection] as Table;
        await clearLibraryBookCollection(libraryBookId, collection, source);
        await table.bulkPut(items);
        await importsService.save(collection, libraryBookId);
      });
    } catch (error) {
      if (globalThis.$logger)
        globalThis.$logger.error(
          'saveLibraryBookCollectionItems ::',
          libraryBookId,
          collection,
          error.message
        );
    }
  };

  return {
    saveCollectionItems,
    saveLibraryBookCollectionItems,
  };
};
